import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '@/api/axios';
import { Bell } from '@phosphor-icons/react';

const fmtQ = (n) => `Q ${Number(n || 0).toLocaleString('es-GT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const SeguimientoCotizaciones = ({ dias = 3 }) => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/cotizaciones/seguimiento?dias=${dias}`)
      .then((r) => setData(r.data))
      .catch(() => {});
  }, [dias]);

  if (!data || !data.cotizaciones?.length) return null;

  return (
    <div className="bg-amber-500/10 border-2 border-amber-500/40 rounded-[14px] p-4 mb-4" data-testid="seguimiento-cotizaciones-card">
      <div className="flex items-center gap-2 mb-2">
        <Bell size={18} weight="fill" className="text-amber-500" />
        <p className="text-xs font-black uppercase tracking-wide text-amber-600">
          Cotizaciones por dar seguimiento ({data.total})
        </p>
      </div>
      <p className="text-[10px] text-[var(--text-muted)] mb-3">
        Llevan {dias}+ días sin convertirse en venta — contacta al cliente para no perder la oportunidad.
      </p>
      <div className="space-y-1.5">
        {[...data.cotizaciones].sort((a, b) => (b.dias - a.dias) || ((b.total || 0) - (a.total || 0))).slice(0, 6).map((c) => (
          <div key={c.id} className="flex items-center gap-2 bg-[var(--surface)] border border-[var(--border)] rounded-[10px] px-3 py-2"
            data-testid={`seguimiento-cot-${c.id}`}>
            <span className="text-[10px] font-black text-amber-600 bg-amber-500/15 px-1.5 py-0.5 rounded shrink-0">{c.dias}d</span>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-bold truncate">⚠️ {c.cliente}</p>
              <p className="text-[10px] text-[var(--text-muted)] truncate">
                Cotización {c.numero} · {fmtQ(c.total)} · {c.dias} día{c.dias !== 1 ? 's' : ''} sin movimiento · {c.estado}
              </p>
            </div>
            {c.telefono && (
              <a href={`tel:${c.telefono}`} className="h-8 px-2.5 inline-flex items-center rounded-md bg-emerald-600 hover:bg-emerald-700 text-white text-[10px] font-black shrink-0"
                data-testid={`seguimiento-llamar-${c.id}`}>📞 LLAMAR</a>
            )}
            <button onClick={() => navigate(`/cotizador/${c.id}`)}
              className="h-8 px-2.5 rounded-md border border-[var(--border)] text-[10px] font-black text-[var(--text)] hover:border-amber-500/60 shrink-0"
              data-testid={`seguimiento-ver-${c.id}`}>👁 VER</button>
          </div>
        ))}
        {data.total > 6 && (
          <p className="text-[10px] text-[var(--text-muted)] text-center pt-1">+ {data.total - 6} más en el módulo Cotizador</p>
        )}
      </div>
    </div>
  );
};
